import React, { Component } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg';
import del from "../../../../assets/img/svg/Del.svg"
import Autocomplete from "react-autocomplete";
import { getOPA_ListView, getOPAActivity, deletemultiOPA } from "../../../../actions/OPAAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import moment from "moment";
import Pagination from "../../../custom/Pagination";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getSettingsFormat } from "../../../../actions/SettingsAction";

class ListViewOPA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            ProjectId: 0,
            Delete: [],
            index:2,
            render: false,
            OPA_ListView: [],
            isChecked: false,
            isView: false,
            searchData: {
                Activity: '',
                PlannedDateFrom: '',
                PlannedDateTo: '',
                CompletionDateFrom: '',
                CompletionDateTo: '',
                SortBy:'planneddate',
                SortOrder:'asc',
                PageNumber: 1,
                PageSize: 500,
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ModifiedBy = localStorage.getItem("UserRoles");
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})
        dispatch(getlookupdocinfo("Operation"));
        this.getSettingsFormat(this.state.ProjectId)
        localStorage.removeItem("OPAEditId")
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getSettingsFormat = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Operation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Operation").addClass("d-none");
        $("#Operation").removeClass("d-block");
        $("#OPAL").removeClass("active-color");
        $("#OPAT").removeClass("fw-bolder");
    }

    dataTable = (data, id) => {
        let apiUrl = API.OPA_LISTVIEW + '?projectId=' + id + '&Activity=' + data.Activity + '&PlannedDateFrom=' + data.PlannedDateFrom + '&PlannedDateTo=' + data.PlannedDateTo + '&CompletionDateFrom=' + data.CompletionDateFrom + '&CompletionDateTo=' + data.CompletionDateTo + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder +'&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    destroyDataTable("staffTable");
                    this.props.dispatch({ type: "OPA_LISTVIEW", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isView === false ? false : true }, { type: 'day', targets: [2, 3] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder])
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
                else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
            });
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#OPE1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Operation1 .MuiListItemText-primary").addClass("fw-bolder");
        $(".Operation").removeClass("d-none");
        $(".Operation").addClass("d-block");
        $("#OPAL").addClass("active-color");
        $("#OPAT").addClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebar");
    };

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/operationplanningachievements/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/operationplanningachievements/edit")
    };

    ViewPage = () => {
        this.props.navigate("/operationplanningachievements/view")
    };

    DeleteItem = () => {
        const { Delete } = this.state;
        window.$("#deletepopup").modal("hide");
        this.deletemultiOPA(Delete, this.state.ProjectId, this.state.ModifiedBy)
    };

    deletemultiOPA = (data, id, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
        let apiUrl = API.OPA_LISTVIEW + '/ids?' + ids + '&modify=' + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,

        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Delete = [];
                    this.setState({});
                    $('input[type=checkbox]').prop('checked', false);
                    this.dataTable(this.state.searchData, this.state.ProjectId);
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {

                }
            });
    };

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // this.props.dispatch(getOPA_ListView(this.state.searchData, this.state.ProjectId));
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
        // this.props.dispatch(getOPA_ListView(this.state.searchData, this.state.ProjectId))
    }

    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            Activity: '',
            PlannedDateFrom: '',
            PlannedDateTo: '',
            CompletionDateFrom: '',
            CompletionDateTo: '',
            SortBy:'planneddate',
            SortOrder:'asc',
            PageNumber: 1,
            PageSize: 500,
        };
        this.state.searchData = input;
        this.setState({});
        // this.props.dispatch(getOPA_ListView(this.state.searchData, this.state.ProjectId))
        //this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Activity = e.target.value;
        this.setState({});
    };
    handleDateChange = (e, node) => {
        this.state.searchData[node] = e.target.value
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Activity = e;
        this.setState({});
    };
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=2;
        this.state.searchData.SortBy='planneddate'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        // this.props.dispatch(getOPA_ListView(this.state.searchData, this.state.ProjectId))
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }

    handleCheckboxChange = (e, x) => {
        const { Delete } = this.state;
        if (Delete.length == 0) {
            Delete.push(x)
        }
        else {
            if (Delete.filter((i) => i == x).length == 1) {
                Delete.map((i, ind) => (
                    i == x ?
                        Delete.splice(ind, 1)
                        : ""
                ))
            } else {
                Delete.push(x)
            }
        }
        this.setState({})
        if (Delete.length == 1) {
            localStorage.setItem("OPAEditId", Delete[0])
        }
    }
    handleSort = (data, ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index: ind,
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    render() {
        let { classes, menuToggle, OPA_Actvity } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4 ">
                                <div className="col-6  mt-auto" >
                                    <List className="pt-3 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"OPE" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="OPE" className="naviIcon ml-auto" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Operation Planning and Achievement</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto border-top" : "ml-auto"} style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isView ? <> {this.state.isMobile ? <table className="dataTable" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}  `} disabled={this.state.Delete.length == 1 ? false : true} onClick={this.EditPage} ><img src={Edit} style={{ marginTop: '-4px', opacity: this.state.Delete.length == 1 ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button}`} disabled={this.state.Delete.length > 0 ? false : true} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: this.state.Delete.length > 0 ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                </td>
                                <td className="border-right text-center">
                                    <button disabled={this.state.isView == true ? false : true} className={classes.button} onClick={this.AddNew}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isView == true ? '' : '0.5' }}></i>Add New</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <>
                            <div className="row  border-bottom">
                                <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">
                                    <button className={`${classes.button} pl-3`} disabled={(this.state.Delete.length == 1 && this.state.isView == true) ? false : true} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: (this.state.Delete.length == 1 && this.state.isView == true) ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                    <button className={`${classes.button}`} disabled={(this.state.Delete.length > 0 && this.state.isView == true) ? false : true} style={{ minWidth: '70px' }} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: (this.state.Delete.length > 0 && this.state.isView == true) ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                    <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                        <button className={classes.button} disabled={this.state.isView == true ? false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isView == true ? '' : '0.5' }}></i>Add New</button>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    </>
                        :
                        <></>}
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Operation Planning and Achievement</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter</button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="staffTable" className="table table-hover product_table">
                                    <thead>
                                        <tr className="">
                                            <th className=" border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left" style={{ width: '25%', minWidth: window.innerWidth < 1000 ? '300px' : "" }} onClick={() => this.handleSort('activity', 1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Activity</span></th>
                                            <th className="border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '45px' : "" }} onClick={() => this.handleSort('planneddate', 2)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Planned Date</span></th>
                                            <th className="border-right" style={{ width: '13%', minWidth: window.innerWidth < 1000 ? '50px' : "" }} onClick={() => this.handleSort('completiondate', 3)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Date of Completion</span></th>
                                            <th className="border-right" style={{ width: '49%', minWidth: window.innerWidth < 1000 ? '400px' : "" }} onClick={() => this.handleSort('reasons', 4)}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Reasons for Deviation</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.OPA_ListView?.Data ? this.props.OPA_ListView?.Data.map((item, value) => (
                                            <tr key={item.Id}>
                                                <td className="spandoc-td  border-left align-middle" width="3%"><input type="checkbox" style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, item.OperationPlanId)} /></td>
                                                <td className="border-right border-left spandoc-td align-middle">{item.Activity}</td>
                                                <td className="spandoc-td border-right align-middle">{item.PlannedDate && moment(item.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                <td className="spandoc-td border-right align-middle">{item.CompletionDate && moment(item.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                <td className="spandoc-td border-right align-middle">{item.ReasonsForDeviation}</td>
                                            </tr>
                                        )) : null
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true" >
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title " id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Activity</label></div>
                                            <div className="col-7">
                                                <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.Activity}
                                                        inputProps={{
                                                            placeholder: "Activity",
                                                        }}
                                                        items={OPA_Actvity ?? []}
                                                        getItemValue={(item) => item.Name}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" key={item}>{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }} />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                key={item}
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.Name}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Planned Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    value={this.state.searchData.PlannedDateFrom && moment(this.state.searchData.PlannedDateFrom).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.PlannedDateFrom && moment(this.state.searchData.PlannedDateFrom).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "PlannedDateFrom") }}
                                                    className='form-control border-radius lPlannedDateFrom'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Planned Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.PlannedDateTo && moment(this.state.searchData.PlannedDateTo).format("yyyy-MM-DD")}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.PlannedDateTo && moment(this.state.searchData.PlannedDateTo).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "PlannedDateTo") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius lPlannedDateTo'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Completion Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    value={this.state.searchData.CompletionDateFrom && moment(this.state.searchData.CompletionDateFrom).format("yyyy-MM-DD")}
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.CompletionDateFrom && moment(this.state.searchData.CompletionDateFrom).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "CompletionDateFrom") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius lCompletionDateFrom'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Completion Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    value={this.state.searchData.CompletionDateTo && moment(this.state.searchData.CompletionDateTo).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.CompletionDateTo && moment(this.state.searchData.CompletionDateTo).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "CompletionDateTo") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius lCompletionDateTo'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.props.OPA_ListView?.pagination?.PageCount) || (this.props.OPA_ListView?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div> */}
            </>
        );

    }
}


function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        OPA_ListView: state.OPAReducer.OPA_ListView || [],
        OPA_Actvity: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
    };
}

ListViewOPA.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewOPA))
);
